"use client";

import { useSession } from "next-auth/react";
import Link from "next/link";
import { Suspense } from "react";
import { NavigationUserAvatar } from "@/components/blocks/navigation-user-avatar";
import { Button } from "@/components/ui/button";
import { ActionLink } from "@/shared/action-link";
import { Feed } from "@/shared/notifications/feed";

export default function UserHeader({ showCreateButton = true }: { showCreateButton?: boolean }) {
  const { data: session, status } = useSession();

  if (status === "loading") {
    return <div></div>;
  }

  return session?.user ? (
    <>
      {showCreateButton && (
        <>
          <div className="hidden text-sm font-bold xl:block">
            <ActionLink text="Create Video" link="/create" />
          </div>

          <div className="hidden text-sm font-bold md:block xl:hidden">
            <ActionLink text="Create" link="/create" />
          </div>
        </>
      )}
      <Suspense fallback={<span className="loading loading-dots loading-md"></span>}>
        <Feed />
        <NavigationUserAvatar user={session.user} />
      </Suspense>
    </>
  ) : (
    <>
      <div className="flex items-center space-x-4">
        <Link href="/sign-in" className="hidden md:block">
          Log In
        </Link>
        <Button asChild>
          <Link href="/sign-up">
            Sign Up <span className="hidden lg:inline-block">- It&apos;s Free</span>
          </Link>
        </Button>
      </div>
    </>
  );
}
